const single_sign_on = {
    forbidden_domains: 'Недопустимы публичные домены электронной почты.',
    duplicated_domains: 'Есть дублирующиеся домены.',
    /** UNTRANSLATED */
    invalid_domain_format: 'Invalid domain format.',
    /** UNTRANSLATED */
    duplicate_connector_name: 'Connector name already exists. Please choose a different name.',
};
export default Object.freeze(single_sign_on);
